import { render, staticRenderFns } from "./legalDocuments.vue?vue&type=template&id=481d9aab&scoped=true&"
import script from "./legalDocuments.vue?vue&type=script&lang=js&"
export * from "./legalDocuments.vue?vue&type=script&lang=js&"
import style0 from "./legalDocuments.vue?vue&type=style&index=0&id=481d9aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d9aab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481d9aab')) {
      api.createRecord('481d9aab', component.options)
    } else {
      api.reload('481d9aab', component.options)
    }
    module.hot.accept("./legalDocuments.vue?vue&type=template&id=481d9aab&scoped=true&", function () {
      api.rerender('481d9aab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/documents/legalDocuments.vue"
export default component.exports